import { motion } from "framer-motion";

const programs = [
  {
    title: "Pre-Primary",
    subtitle: "(Nursery, LKG, UKG)",
    description:
      "Our foundation years emphasize joyful learning, motor skills, and early social development. With fun-filled, theme-based teaching, we lay the groundwork for lifelong curiosity.",
  },
  {
    title: "Primary School",
    subtitle: "(Grades 1–3)",
    description:
      "Focused on building strong academic and emotional foundations. We use activity-based learning, nurturing creativity, communication, and confidence in every child.",
  },
  {
    title: "Middle School",
    subtitle: "(Grades 3-5)",
    description:
      "As students grow, so does our focus on critical thinking, collaborative learning, and interdisciplinary exploration — bridging academics with real-world understanding.",
  },
  {
    title: "Beyond Academics",
    description:
      "Our holistic programs include sports, music, dance, arts, robotics, coding, and mindfulness practices to support every child’s interests and talents.",
  },
];

const ProgramsPage = () => {
  return (
    <section className="bg-[#f9fafb] text-[#14213D] py-16 px-6 md:px-20">
        <section className="relative h-[60vh] flex items-center justify-center bg-cover bg-center text-white" style={{ backgroundImage: `url(https://res.cloudinary.com/dkmxvgmxd/image/upload/v1755621363/op-bg_riohoh.jpg)` }}>
        <div className="bg-black/50 absolute inset-0"></div>
        <motion.div 
          className="relative z-10 text-center px-4"
          initial={{ opacity: 0, y: 20 }} 
          animate={{ opacity: 1, y: 0 }} 
          transition={{ duration: 1 }}
        >
          <h1 className="text-4xl md:text-5xl font-bold mb-2">Learning That Grows With Your Child</h1>
          <p className="text-lg md:text-xl">From playful beginnings to empowered adolescence — our programs are thoughtfully designed to support every stage of your child’s journey.</p>
        </motion.div>
      </section>
      <div className="max-w-6xl mx-auto space-y-16 my-20">
        {/* Heading */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h1 className="text-4xl font-bold mb-4 text-center text-schoolRed text-rl">Our Programs</h1>
          <p className="text-lg text-center text-gray-700 max-w-3xl mx-auto text-lato">
            At Springdales, every stage of a child’s growth is nurtured with care and purpose. Our programs evolve with your child, 
            fostering discovery, excellence, and joy in learning.
          </p>
        </motion.div>

        {/* Program Cards */}
        <div className="grid gap-8 md:grid-cols-2 file:">
          {programs.map((program, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5}}
              viewport={{ once: true }}
            >
              <div className="bg-gray-100 rounded-2xl shadow-lg">
                <div className="p-6">
                  <h2 className="text-2xl font-semibold mb-2 text-schoolBlue">{program.title}</h2>
                  <h3 className="text-xl font-semibold mb-2 text-schoolylw">{program.subtitle}</h3>
                  <p className="text-gray-600 leading-relaxed text-lato">{program.description}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProgramsPage;
